import req from '../../api/request'
import { ENDPOINTS } from '../../api/endpoints'

export const getGameRosters = async (gameId) => {
  const { data } = await req(ENDPOINTS.GAMES.GET_GAME_ROSTERS(gameId))
  return data
}
